import { useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query'

import Season from './Season';
import { api } from '../../AppConfig';

function RoutedSeason() {
  // Access the client
  const queryClient = useQueryClient();
  // Access the path params
  const { id } = useParams();
  // console.warn('che id mi viene passato?', id);

  // return nothing if there's no path param
  // if (!id) return (<div></div>);

  //otherwise we fetch the data and pass to the display component
  const seasonQuery = useQuery({ 
    queryKey: [ `season${id}` ], 
    queryFn: () => 
      fetch(api.seasons().detailsById(id).href).then((res) =>
        res.json(), 
      )
  })
  const rankingQuery = useQuery({
    queryKey: [`seasonRanking${id}`],
    queryFn: () =>
      fetch(api.seasons().getRanking(id).href).then((res) =>
        res.json(), 
      )
  })
  const stagesQuery = useQuery({
    queryKey: [`seasonStages${id}`],
    queryFn: () =>
      fetch(api.seasons().getStages(id).href).then((res) =>
        res.json(),
      )
  })
  const metagameQuery = useQuery({
    queryKey: [`seasonStats${id}`],
    queryFn: () =>
      fetch(api.seasons().getMetagame(id).href).then((res) =>
      res.json(),
      )
  })
  return <Season id={id} season={seasonQuery} metagame={metagameQuery} ranking={rankingQuery} stages={stagesQuery} />;
}

export default RoutedSeason;